export const TRANSACTION_CONSTANTS = {
  // Transactions
  GET_TRANSACTIONS_REQUEST: 'GET_TRANSACTIONS_REQUEST',
  GET_TRANSACTIONS_SUCCESS: 'GET_TRANSACTIONS_SUCCESS',
  GET_TRANSACTIONS_FAILURE: 'GET_TRANSACTIONS_FAILURE',
  RESET_TRANSACTION_STATE: 'RESET_TRANSACTION_STATE',
};